/**
 * Kurzzugriff auf Session-Collection (Phase 0: sessionStorage via StorageEngine).
 */

import { getStorageEngineRef } from './storageEngineRef';
import { SESSION_COLLECTION } from './StorageEngine';

export function sessionGet(key) {
  const v = getStorageEngineRef().get(SESSION_COLLECTION, key);
  return v === undefined ? null : v;
}

export function sessionSet(key, value) {
  getStorageEngineRef().put(SESSION_COLLECTION, key, value);
}

export function sessionRemove(key) {
  getStorageEngineRef().delete(SESSION_COLLECTION, key);
}
